import Button from '@atlaskit/button/new';
import ButtonLink, { AnchorLink } from 'components/common/ButtonLink';
import ModalDialog, {
  ModalTransition,
  ModalBody,
  ModalTitle,
  ModalHeader,
  ModalFooter,
} from '@atlaskit/modal-dialog';
import traceUFOPress from '@atlassian/react-ufo/trace-press';

import { FormattedMessage } from 'react-intl';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { Dimensions } from 'components/visuals';
import { State } from 'model/State';
import { selectEditedCartOrderResponse } from '../duck/selectors';
import { fetchOrderPDF } from '../duck/actions/orders';
import { OrderResult } from '../duck/models';
import { ORDER_INVOICE_ACTION_PDF_UFO_NAME } from 'util/ufoNameConstants';

const StyledDiv = styled.div`
  display: inline-block;
  width: ${Dimensions.units(2)}px;
`;

const EditedOrderModal = ({ items }: { items: OrderResult[] | null }) => {
  const dispatch = useDispatch();

  const editedUuid = useSelector((state: State) => state.location.query?.editedUuid);
  const editedUuidCart = useSelector(selectEditedCartOrderResponse);

  const [isModalOpened, setIsModalOpened] = useState(false);
  const [rowItem, setRowItem] = useState<OrderResult | undefined>(undefined);

  useEffect(() => {
    if (items && items.length) {
      setRowItem(items.find(({ uuid }) => uuid === editedUuid));
    }
  }, [items]);

  useEffect(() => {
    if (editedUuid && editedUuidCart?.quoteNumber && rowItem?.id) {
      setIsModalOpened(true);
    }
  }, [editedUuid, editedUuidCart, rowItem]);

  const onClose = () => {
    setIsModalOpened(false);
  };

  const handlePDFDownload = (e) => {
    e.stopPropagation();
    if (rowItem) {
      traceUFOPress(ORDER_INVOICE_ACTION_PDF_UFO_NAME);
      dispatch(fetchOrderPDF(rowItem.orderId));
    }
  };

  return (
    <ModalTransition>
      {isModalOpened && (
        <ModalDialog autoFocus shouldCloseOnEscapePress width="medium">
          <ModalHeader>
            <ModalTitle testId="order-edit-success-modal-title">
              <FormattedMessage
                id="mac.orders.order-edit-success.modal.title"
                defaultMessage="Saved successfully"
              />
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <>
              <FormattedMessage
                id="mac.orders.order-edit-success.modal.content"
                defaultMessage="Quote {quoteNumber} has been saved."
                values={{
                  quoteNumber: <b>{editedUuidCart?.quoteNumber}</b>,
                }}
              />
              <br />
              <br />
              <ButtonLink onClick={handlePDFDownload}>
                <FormattedMessage
                  id="mac.orders.order-edit-success.modal.content.download-button"
                  defaultMessage="Download PDF"
                />
              </ButtonLink>
              <StyledDiv />
              <AnchorLink href={`/purchase/checkout/payment?uuid=${rowItem?.uuid}`}>
                <FormattedMessage
                  id="mac.orders.order-edit-success.modal.content.pay-button"
                  defaultMessage="Pay the quote"
                />
              </AnchorLink>
            </>
          </ModalBody>
          <ModalFooter>
            <>
              <Button onClick={onClose} appearance="subtle" autoFocus>
                <FormattedMessage
                  id="mac.orders.order-edit-success.modal.button.close"
                  defaultMessage="Close"
                />
              </Button>
            </>
          </ModalFooter>
        </ModalDialog>
      )}
    </ModalTransition>
  );
};

export default EditedOrderModal;
